// src/components/OnboardingGate.jsx
//
// Decides when the onboarding agreement is shown.
//
// Mounted once inside AuthProvider (see App.jsx) rather than on individual
// pages. Two reasons:
//
//   1. The brief requires the agreement "before first use" and blocks account
//      activation until confirmed — that means every authenticated surface,
//      not just the analyse page.
//   2. Mounting per-page means every new page is a chance to forget it. One
//      mount point cannot be forgotten.
//
// This component decides *whether* to show it. It is not the enforcement
// point: the analysis endpoints refuse server-side while terms_accepted_at
// is NULL, so removing this from the tree restores nothing.

import { useAuth } from '../context/AuthContext'
import OnboardingAgreement from './OnboardingAgreement'

export default function OnboardingGate() {
    const { user, loading, refreshUser } = useAuth()

    // Nothing to gate while the session is still resolving, or for logged-out
    // visitors reading the public pages.
    if (loading || !user) return null

    // Already accepted.
    if (user.terms_accepted) return null

    return <OnboardingAgreement onAccepted={refreshUser} />
}